/**
 * 扁平化流程节点数据，并将属性名转换为大写
 * @param {Object} node 当前节点
 * @param {String|null} preId 前置节点ID
 * @param {Number} level 当前层级
 * @param {Array} flatList 扁平化结果数组
 */
export function flattenProcessNode(node, preId = null, level = 1, flatList = []) {
  if (!node) return;

  // 生成唯一 nodeId（如果没有的话）
  const nodeId = node.nodeId || `node_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;

  // 校验 nodeUserType
  const isNodeUserValid = node.nodeUserType && ((node.nodeUserType.valueList.length > 0) || Boolean(node.nodeUserType.value));

  // 特殊处理发起人节点（type 0）
  let nodeUserType;
  if (node.type === 0) {
    // 发起人节点：如果nodeUserType.type是'ALL'，则表示"所有人"
    if (node.nodeUserType && node.nodeUserType.type === 'ALL') {
      nodeUserType = {
        NODETYPE: 'ALL',
        VALUE: 'ALL',
        VALUENAME: '所有人',
        VALUELIST: ['ALL']
      };
    } else if (isNodeUserValid) {
      // 有效的用户类型数据
      nodeUserType = {
        NODETYPE: node.nodeUserType.type,
        VALUE: node.nodeUserType.value,
        VALUENAME: node.nodeUserType.valueName,
        VALUELIST: node.nodeUserType.valueList
      };
    } else {
      // 默认为"所有人"
      nodeUserType = {
        NODETYPE: 'ALL',
        VALUE: 'ALL',
        VALUENAME: '所有人',
        VALUELIST: ['ALL']
      };
    }
  } else {
    // 非发起人节点
    nodeUserType = isNodeUserValid ? {
      NODETYPE: node.nodeUserType.type,
      VALUE: node.nodeUserType.value,
      VALUENAME: node.nodeUserType.valueName,
      VALUELIST: node.nodeUserType.valueList
    } : {
      NODETYPE: "user",
      VALUE: "",
      VALUENAME: "",
      VALUELIST: []
    };
  }

  // 当前节点 - 属性名转换为大写，特定属性名修改
  const currentNode = {
    NODEID: nodeId,
    NODENAME: node.nodeName || "未命名节点",
    NODETYPE: node.type,
    ERROR: node.error ? !isNodeUserValid : '',
    NODEUSERTYPE: nodeUserType,
    EXAMINEMODE: node.examineMode || null,
    PRIORITYLEVEL: node.priorityLevel || null,
    CONDITIONSTRING: node.conditionString || null,
    PREID: preId || null,
    LVL: level,
    IDSEQ: node.IDSEQ || ''
  };

  flatList.push(currentNode);

  // 路由节点（type 4）处理：包含子节点和条件节点
  if (node.type === 4) {
    if (node.childNode) {
      flattenProcessNode(node.childNode, nodeId, level + 1, flatList);
    }

    if (Array.isArray(node.conditionNodes)) {
      node.conditionNodes.forEach((conditionNode, index) => {
        const virtualId = `cond_${nodeId}_${index}`;
        
        // 处理条件列表中的字段名转换
        let conditionList = [];
        if (conditionNode.conditionList && 
            conditionNode.conditionList[0] && 
            conditionNode.conditionList[0].conditionChildrenNodes) {
          conditionList = conditionNode.conditionList[0].conditionChildrenNodes.map(item => ({
            LEFTFIELDS: item.leftFileds,
            CENTERFIELDS: item.centerFileds,
            RIGHTFIELDS: item.rightFileds,
            LEFTFIELDSNAME: item.leftFiledsName,
            LEFTFIELDSTYPE: item.leftFiledsType
          }));
        }

        const conditionData = {
          NODEID: virtualId,
          NODENAME: conditionNode.nodeName || `条件${index + 1}`,
          NODETYPE: conditionNode.type,
          PRIORITYLEVEL: conditionNode.priorityLevel || null,
          CONDITIONLIST: conditionList,
          PREID: nodeId,
          LVL: level + 1,
          IDSEQ: conditionNode.IDSEQ || ''
        };
        flatList.push(conditionData);

        // 条件分支的子节点递归处理
        flattenProcessNode(conditionNode.childNode, virtualId, level + 2, flatList);
      });
    }
  }

  // 非路由子节点处理
  if (node.childNode && node.type !== 4) {
    flattenProcessNode(node.childNode, nodeId, level + 1, flatList);
  }

  return flatList;
}